import { MenuPosition } from 'components/shared/menu/menu-content';
import { clampToViewport, fitsAfter, fitsBefore, VIEWPORT_MARGIN } from 'components/shared/viewport';

const marginFromContent = 4;

export function calculateMenuPosition(triggerRect: DOMRect, menuRect: DOMRect, position: MenuPosition) {
  const { left, top, bottom, width } = triggerRect;
  const { width: menuWidth, height: menuHeight } = menuRect;

  const viewportWidth = window.innerWidth;
  const viewportHeight = window.innerHeight;

  let x: number;
  switch (position) {
    case 'left':
      x = left;
      break;
    case 'right':
      x = left + width - menuWidth;
      break;
    case 'center':
      x = left + width / 2 - menuWidth / 2;
      break;
    default:
      throw Error(`${position} must be implemented`);
  }

  // Clamp horizontally so the menu never spills off the left/right edge.
  x = clampToViewport(x, menuWidth, viewportWidth);

  const y = calculateVerticalPosition(top, bottom, menuHeight, viewportHeight);

  return { x, y };
}

function calculateVerticalPosition(top: number, bottom: number, menuHeight: number, viewportHeight: number) {
  const belowY = bottom + marginFromContent;
  // Room the menu needs on a side: the content gap plus the viewport-edge margin.
  const edgeMargin = marginFromContent + VIEWPORT_MARGIN;

  // Enough room below the trigger — the default placement.
  if (fitsAfter(bottom, menuHeight, viewportHeight, edgeMargin)) return belowY;

  // Not enough below, but it fits above — flip upward.
  if (fitsBefore(top, menuHeight, edgeMargin)) return top - menuHeight - marginFromContent;

  // Fits neither: pin to whichever side has more room, clamped to the viewport so
  // the menu's own overflow-y scroll handles the remainder (see max-height in menu-content).
  const spaceBelow = viewportHeight - bottom;
  const spaceAbove = top;
  return spaceBelow >= spaceAbove
    ? Math.min(belowY, viewportHeight - menuHeight - VIEWPORT_MARGIN)
    : Math.max(VIEWPORT_MARGIN, top - menuHeight - marginFromContent);
}
